// ABOUTME: UI mirror of the server's isHierarchyMarketScoped, fed by the `/api/user` market context.
// ABOUTME: A hierarchy is market-scoped when the module is on and it is in marketScoping.scopedHierarchyIds.

import type { MarketContext } from '../types';

export const isHierarchyMarketScoped = (
    marketContext: MarketContext | null | undefined,
    hierarchyId: string | null | undefined,
): boolean => {
    if (!marketContext || !hierarchyId) return false;
    return marketContext.scopedHierarchyIds.includes(hierarchyId);
};
